const getTopBar = (backFun) => {
  try {
    // eslint-disable-next-line no-undef
    BarTop.postMessage('height')
  } catch (e) {
    console.log('调用异常')
  }
  window['getTopBar'] = (resultMessage) => {
    backFun(resultMessage)
  }
}

const toSellerFun = (str) => {
  try {
    console.log("11111111111-"+str);
    // eslint-disable-next-line no-undef
    ToSeller.postMessage(str)
  } catch (e) {
    console.log('toSellerFun调用异常')
  }
}
const getVersion = (backFun) => {
  try {
    // eslint-disable-next-line no-undef
    appPackageInfo.postMessage('')
  } catch (e) {
    console.log('getVersion调用异常')
  }
  window['onGetVersion'] = (result) => {
    backFun(result)
  }
}

export { getTopBar,toSellerFun,getVersion}
